import { isOpenGoal, tierOf } from './lib';
import { YearPlan, SlotCard } from './YearPlan';

export function BizPlan({ goals, onOpen, onNew }) {
  const closed = goals.filter((g) => !isOpenGoal(g));
  return (
    <div data-testid="biz-plan">
      <YearPlan goals={goals} onOpen={onOpen} onNew={onNew} />
      {closed.length > 0 && (
        <details className="mt-10" data-testid="biz-plan-closed">
          <summary className="cursor-pointer text-sm font-semibold inline-flex items-center gap-2" style={{ color: 'var(--ink-2)' }}>Achieved & dropped goals <span className="biz-count">{closed.length}</span></summary>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 mt-4 opacity-80">
            {closed.map((g) => <SlotCard key={g.id} goal={g} tier={tierOf(g)} size="mini" onOpen={onOpen} />)}
          </div>
        </details>
      )}
    </div>
  );
}
